import myProfileEpic from "./my-profile";
import patchProfileEpic from "./patch-profile";

import { combineEpics } from "redux-observable";

export default combineEpics(myProfileEpic, patchProfileEpic);
